import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CategorieComponent } from './categorie.component';
import { CategorieListComponent } from './categorie-list/categorie-list.component';
import { CategorieDetailsComponent } from './categorie-details/categorie-details.component';
import { CategorieByMarchioComponent } from './categorie-by-marchio/categorie-by-marchio.component';
import { CategorieEditComponent } from './categorie-edit/categorie-edit.component';
import { CategorieCreateComponent } from './categorie-create/categorie-create.component';


const routes: Routes = [
    {
        path: '',
        component: CategorieComponent,
        children: [
            {
                path: '',component:CategorieListComponent

            },
            {
                path: 'details/:id',
                component:CategorieDetailsComponent

            }
            ,
            {
                path: 'byMarchio',
                component:CategorieByMarchioComponent

            },
            {
                path: 'edit/:id',
                component:CategorieEditComponent

            },
            {
                path: 'create',
                component:CategorieCreateComponent

            }
        ]



    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CategorieRoutingModule {

}
